import { CAMPAIGN_DATA_TAB_MESSAGES, CampaignDataTabMessages } from "./campaign-data.messages";
import { CAMPAIGN_REQUEST_MESSAGES, CampaignRequestMessages } from "./campaign-request-messages";
import { CAMPAIGNS_STATUS_MESSAGES, CampaignsStatusMessages } from "./campaigns-status.messages";
import { CONTACT_INFO_TAB_MESSAGES, ContactInfoTabMessages } from "./contact-info-tab.messages";
import { EXECUTION_LOG_MESSAGES, ExecutionLogMessages } from "./exception-log.messages";
import { PRODUCTS_DATA_TAB_MESSAGES, ProductsDataTabMessages } from "./poducts-data-tab.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { CONSENT_STATUS_MESSAGES, ConsentStatusMessages } from "../consent-status.messages";
import { GENDER_MESSAGES, GenderMessages } from "../gender/gender.messages";
import {
  IMAGE_VALIDATION_MESSAGES,
  ImageValidationMessages,
} from "../images/Image-validation.messages";
import { MULTI_SELECT_MESSAGES, MultiSelectMessages } from "../inputs/multi-select.messages";

export type CampaignFormMessages = MultiSelectMessages &
  CampaignsStatusMessages &
  CampaignRequestMessages &
  ImageValidationMessages &
  ActionButtonMessages &
  CampaignDataTabMessages &
  ContactInfoTabMessages &
  GenderMessages &
  ProductsDataTabMessages &
  ExecutionLogMessages &
  ConsentStatusMessages & {
    listNameLabel: string;
    parentListIdLabel: string;
    factorLabel: string;
    chargeOverValueLabel: string;
    chargeOverAmountLabel: string;
    chargeBelowValueLabel: string;
    chargeBelowAmountLabel: string;
    internalListLabel: string;

    errorRequiredListName: string;
    errorRequiredParentListId: string;
    errorRequiredFactor: string;
    errorRequiredChargeOverValue: string;
    errorRequiredChargeOverAmount: string;
    errorRequiredChargeBelowValue: string;
    errorRequiredChargeBelowAmount: string;
    errorRequiredInternalList: string;

    noneOptionLabel: string;

    deleteImageButton: string;
    addImageButton: string;

    // Status Labels
    statusDraft: string;
    statusActive: string;
    statusInactive: string;
    statusRejected: string;
    statusHold: string;
    statusCompleted: string;

    // Type Labels
    typePromotionalPrice: string;
    typeDiscountCoupon: string;
    typeSimpleMessage: string;

    // Platforms Type Labels
    typeWHATSAPP: string;
    typeVTEX: string;
    typeTRAY: string;

    uploadImageButton: string;

    citiesLabel: string;
    errorFetchingContacts: string;

    cartOption: string;
    catalogOption: string;
    formatLabel: string;

    // Simple Message validation messages
    simpleMessageError: string;
    simpleMessageMaxLength: string;
    simpleMessageStartsWithVariableError: string;
    buttonTextError: string;
    buttonTextMaxLength: string;
    buttonLinkError: string;
    buttonLinkInvalidError: string;
  };

export const CAMPAIGN_FORM_MESSAGES: CampaignFormMessages = {
  // Labels
  listNameLabel: "Nome da lista",
  parentListIdLabel: "Lista pai",
  factorLabel: "Fator",
  chargeOverValueLabel: "Cobrar acima do valor",
  chargeOverAmountLabel: "Cobrar acima da quantidade",
  chargeBelowValueLabel: "Adicionar",
  chargeBelowAmountLabel: "Em preços inferiores a",
  internalListLabel: "Lista interna",

  // Error messages
  errorRequiredListName: "O nome da lista é obrigatório!",
  errorRequiredParentListId: "A lista pai é obrigatória!",
  errorRequiredFactor: "O fator é obrigatório!",
  errorRequiredChargeOverValue: "O valor de 'Cobrar acima do valor' é obrigatório!",
  errorRequiredChargeOverAmount: "O valor de 'Cobrar acima da quantidade' é obrigatório!",
  errorRequiredChargeBelowValue: "O valor de 'Cobrar abaixo do valor' é obrigatório!",
  errorRequiredChargeBelowAmount: "O valor de 'preços inferiores a' é obrigatório!",
  errorRequiredInternalList: "A seleção da lista interna é obrigatória!",

  deleteImageButton: "Remover",
  addImageButton: "Adicionar Imagem",

  // Status Labels
  statusDraft: "Rascunho",
  statusActive: "Ativa",
  statusInactive: "Inativa",
  noneOptionLabel: "Nenhum",
  statusRejected: "Rejeitada",
  statusHold: "Aguardando Aprovação",
  statusCompleted: "Concluída",

  // Type Labels
  typePromotionalPrice: "Preço Promocional",
  typeDiscountCoupon: "Cupom de Desconto",
  typeSimpleMessage: "Mensagem Simples",

  // Type Labels
  typeWHATSAPP: "WHATSAPP",
  typeVTEX: "VTEX",
  typeTRAY: "TRAY",

  uploadImageButton: "Fazer Upload da Imagem da Campanha",

  citiesLabel: "Cidades",

  errorFetchingContacts: "Erro ao buscar os contatos. Tente novamente mais tarde.",

  cartOption: "Carrinho",
  catalogOption: "Catalogo",
  formatLabel: "Formato da Campanha",

  // Simple Message validation messages
  simpleMessageError: "A mensagem é obrigatória",
  simpleMessageMaxLength: "A mensagem deve ter no máximo 1024 caracteres",
  simpleMessageStartsWithVariableError: "A mensagem não pode começar com uma variável",
  buttonTextError: "O texto do botão é obrigatório quando o botão está habilitado",
  buttonTextMaxLength: "O texto do botão deve ter no máximo 20 caracteres",
  buttonLinkError: "O link do botão é obrigatório quando o botão está habilitado",
  buttonLinkInvalidError: "O link deve ser uma URL válida com protocolo http(s)",

  ...CONSENT_STATUS_MESSAGES,
  ...EXECUTION_LOG_MESSAGES,
  ...PRODUCTS_DATA_TAB_MESSAGES,
  ...GENDER_MESSAGES,
  ...CONTACT_INFO_TAB_MESSAGES,
  ...CAMPAIGN_DATA_TAB_MESSAGES,
  ...IMAGE_VALIDATION_MESSAGES,
  ...CAMPAIGN_REQUEST_MESSAGES,
  ...CAMPAIGNS_STATUS_MESSAGES,
  ...MULTI_SELECT_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
